import React from 'react';
import HeroSection from '../components/HeroSection';
import Service from '../components/Service';
import Trusted from '../components/Trusted';
import FeatureProducts from '../components/FeatureProducts';



const Home = () => {
  return (

    <>
    <HeroSection name="Ciana Home Products LLP" />
    <FeatureProducts/>
    <Service />
    <Trusted/>
    </>
  )
  
};


export default Home;
